import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiChats = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "#748094",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M7.139 11.25h3.21M10.625 12.083l-1.35-4.166h-1.05l-1.35 4.166M12.917 12.083V7.917"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "#748094",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M2.5 10a7.46 7.46 0 0 0 1.359 4.297l-.527 2.37 2.37-.526A7.497 7.497 0 1 0 2.5 10",
		clipRule: "evenodd"
	})]
});
export default SvgAiChats;
